/* eslint react/no-danger: "off" */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import panelStyle from 'Styles/panel.css'
import style from './style.css'

export default class TopicCheckboxItem extends Component {
  constructor (props) {
    super(props)
    this.toggleCheckbox = this.toggleCheckbox.bind(this)
  }

  toggleCheckbox () {
    this.props.onEnabledChange(this.props.topic)
  }

  onKeyDown (event) {
    if (event.keyCode === 13) {
      event.target.click()
    }
  }

  renderHiddenText () {
    return (
      <div className={style.questionHidden}>
        Questions on this topic are hidden.
      </div>
    )
  }

  render () {
    const divInline = {
      display: 'inline-block'
    }
    return (
      <div
        data-test-id="topicCheckboxItem"
        className={classnames(panelStyle.small, style.exclusionPanel, !this.props.enabled ? style.disabledPanel : null)}
        tabIndex="0"
      >
        <Row>
          <Col xs={10} sm={11}>
            <div style={divInline}>
              <span
                data-test-id="topicCheckboxItemTitle"
                className={this.props.enabled ? style.topicTitle : style.topicTitleDisable}
                dangerouslySetInnerHTML={{ __html: this.props.topic.label }}
              />
            </div>
          </Col>
          <Col xs={2} sm={1}>
            <div style={divInline}>
              <input
                type="checkbox"
                name="topicCheckbox"
                checked={this.props.enabled}
                className={style.checkbox}
                onChange={this.toggleCheckbox}
                onKeyDown={(event) => this.onKeyDown(event)}
                tabIndex="0"
              />
            </div>
          </Col>
        </Row>
        {this.props.enabled
          ? null
          : this.renderHiddenText()
        }
      </div>
    )
  }
}

TopicCheckboxItem.propTypes = {
  topic: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  onEnabledChange: PropTypes.func.isRequired
}
